/**
 * The chat time stamp (R1791, ui-map-interface.md §8).
 *
 * The SOCIAL switch `chatTimeOn` puts `[HH:MM]` in front of each chat
 * line: the time the line was sent, on the 24-hour clock of the device's
 * own zone. The game chat line carries the hub's wall second
 * (`ChatMsg.unix`) and a clan chat line the meta server's (`at`); a
 * replayed line keeps its first stamp, so a backlog reads the time each
 * line was written. A stamp of 0 is unknown and draws nothing.
 *
 * The form comes from `locale/stamp.ts`, so the game chat and the hub
 * clan chat card write one form.
 */

import { isoTime, zoneId, zoneName } from '../locale/stamp';
import { storedReader } from './localstore';
import { parseSettings } from './settings';
import { SETTINGS_KEY } from './settingskey';

/** The stamp of one line as markup, with the space that follows it, or
 *  '' while the switch is off or the line has no stamp. */
export function chatStampHtml(unixSec: number, on: boolean): string {
  if (!on) return '';
  const t = isoTime(unixSec);
  return t === '' ? '' : `<span class="ts">[${t}]</span> `;
}

/** The zone the stamp reads, as the SOCIAL row names it: the IANA name
 *  of the device's zone, else its short name at `nowSec`, else UTC. */
export function chatStampZone(nowSec: number): string {
  return zoneId() || zoneName(nowSec) || 'UTC';
}

/**
 * The switch as the stored settings blob holds it, for a page that keeps
 * no settings object of its own: the hub clan chat card. The blob parses
 * again only when its text changed, so a card of many lines pays one read
 * of the storage for each line and one parse.
 */
export const storedChatTimeOn: () => boolean =
  storedReader(SETTINGS_KEY, (raw) => parseSettings(raw).chatTimeOn);
